import * as actions from "./Type";
import Instance from "../util/Instance";
import setToken from "../util/SetToken";
import "react-toastify/dist/ReactToastify.css";

export const Get_Total_Salary_branch = (id, from, to) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/TotalBranchMonthSalary/${id}?from=${from}&to=${to}`,
        config
      );
      dispatch({
        type: actions.GET_TOTAL_SALARY_BRANCH,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Get_List_Masrufat = (id, from, to) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(
        `/api/v1/getBranchExpenses/${id}?from=${from}&to=${to}`,
        config
      );
      dispatch({
        type: actions.GET_BRANCH_MASRUFAT,
        payload: res.data.data,
        branch_obj: res.data.data.length !== 0 ? res.data.data[0].branchId : [],
      });
    } catch (error) {}
  };
};

// expenses function

// Create type
export const Create_Type_Exp = (data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.post(
        `/api/v1/ExpensesType`,
        { ...data },
        config
      );
      dispatch({
        type: actions.EXP_CREATE,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
// get exp
export const Get_List_Exp = () => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/expensestypes`, config);
      dispatch({
        type: actions.EXP_LIST,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
/// view exp
export const View_Type_Exp = (eid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/ExpensesType/${eid}`, config);
      dispatch({
        type: actions.EXP_VIEW,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const Delete_Type_Exp = (eid) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      await Instance.delete(`/api/v1/ExpensesType/${eid}`, config);
      dispatch({
        type: actions.EXP_DELETE,
        ex_id: eid,
      });
    } catch (error) {}
  };
};

// update bills
export const Update_Type_Exp = (eid, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.put(
        `/api/v1/ExpensesType/${eid}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.EXP_UPDATE,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};

export const View_Masrufat_Branch = (id) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/getExpense/${id}`, config);
      dispatch({
        type: actions.MASRUFAT_VIEW,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
export const Update_Masrufat_Branch = (id, data) => {
  return async (dispatch) => {
    if (localStorage.token_GPC_admin) {
      setToken(localStorage.getItem("token_GPC_admin"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.put(
        `/api/v1/UpdateExpenseById/${id}`,
        { ...data },
        config
      );
      dispatch({
        type: actions.MASRUFAT_UPDATE,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
